import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { SecurityService } from '../security/security.service';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../core/browser-providers';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';
import { Environment } from '../../environments/enviroment.model';
import { TranslateService } from '../core/translate.service';
import { UpdateEventService } from '../shared-services/update-event.service';
import { Notificacion } from './notificacion.model';
import { MediaService } from '../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../shared-components/modals/dialog.service';
import { SearchInputComponent } from '../shared-components/search-input/search-input.component';

interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-notificacion-list',
  templateUrl: './notificacion-list.component.html',
  styleUrls: ['./notificacion-list.component.scss']
})
@Injectable()
export class NotificacionListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private backendUrl: string;

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'id',  label: 'ID' },
    { name: 'fechaEnvio',  label: 'Fecha de envío' },
    { name: 'texto',  label: 'Texto' },
    { name: 'email',  label: 'Email' },
    { name: 'created_at',  label: 'Fecha de creación' },
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  notificacionFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  notificationsList: Notificacion[] = [];

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;
    this.backendService.get(Notificacion, Notificacion.path + "all", null).toPromise()
    .then((notificaciones) =>{
      this.notificationsList = notificaciones as Notificacion[];
    });
    
    
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  onSearch(searchText) {
    this.filters.search = 'name:' + searchText;
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAddNotificacion() {
    this.router.navigate(['/notificaciones/agregar']);
  }

  onChangePassword(notificacion: Notificacion) {
    this.router.navigate(['/notificaciones/cambiar_password', notificacion.id]);
  }

  onEditNotificacion(notificacion: Notificacion) {
    this.router.navigate(['/notificaciones/editar', notificacion.id]);
  }

  onFiltersChanged(event) {
    
  }

  removeChip(event) {
    
  }

  async onDeleteNotificacion(notificacion: Notificacion) {

    this.dialogService.confirm('Eliminar Usuario',
    '¿Está seguro que desea eliminar la notificación?')
    .then( res => {
      if (res) {
        this.deleteNotificacion(res, notificacion);
      }
    });

  }

  async deleteNotificacion(res, notificacion: Notificacion) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Notificacion.path + notificacion.id);
        this.snackService.success('Notificación eliminada correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }

  }

  funcionPrueba(id){
    console.log("HOLAA");
    console.log(id)
  }

}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion-list.component.ts